/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, {useState} from "react";
import {Link,useHistory,useLocation} from "react-router-dom";
import {default as queryString} from "qs";
import {connect} from "react-redux";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  FormInput,
  Button, Alert
} from "shards-react";
import PropTypes from "prop-types";
import {signup} from "../redux/actions/user";
import {validateEmail} from "../utils/general";
import {PRIVACY_POLICY_URL, USERTERMS_SERVICE_URL} from "../utils/constants";
import packageJson from "../../package.json";

const {version} = packageJson;

const SignUp = ({signup, alerts}) => {

  const history = useHistory();
  const location = useLocation();
  const queryParams = queryString.parse(location.search.replace("?", ""));
  const verificationCode = queryParams.verificationCode;

  const [state, setState] = useState({
    showPassword: false,
    showConfirmPassword: false,
    email: queryParams.login || '',
    password: '',
    confirmPassword: '',
    emailError: '',
    isMinimum8ch: false,
    is1Number: false,
    is1Uppercase: false,
    is1Lowercase: false,
    is1SpecialCh: false,
    isBothMatch: false,
    disablebutton: false
  });

  const onChangeEmail = (e) => {
    setState({
      ...state,
      email: e.target.value,
      emailError: ''
    });
  };

  const passwordStrength = (e) => {
    const passwordValue = e.target.value;
    const LowerRegExp = /[a-z]/;
    const UpperRegExp = /[A-Z]/;
    const NumberRegExp = /(?=.*?[0-9])/;
    const SpecialCRegExp = /(?=.*?[#!@$%^&*])/;

    var varMaxMatch = passwordValue.length >= 8;
    var varMatch = passwordValue === state.confirmPassword;
    setState({
      ...state,
      password: passwordValue,
      is1Number: NumberRegExp.test(passwordValue),
      is1Uppercase: UpperRegExp.test(passwordValue),
      is1Lowercase: LowerRegExp.test(passwordValue),
      is1SpecialCh: SpecialCRegExp.test(passwordValue),
      isMinimum8ch: varMaxMatch,
      isBothMatch: varMatch
    });
  };

  const passwordMatch = (e) => {
    const passwordValue = e.target.value;
    var varMatch = passwordValue === state.password;
    setState({
      ...state,
      confirmPassword: passwordValue,
      isBothMatch: varMatch
    });
  };

  const handleSignUp = async (e) => {
    e.preventDefault();

    if (!validateEmail(state.email)) {
      setState({...state, emailError: 'Please enter a valid email address.'});
      return;
    }

    setState({...state, disablebutton: true});
    const saved = await signup(verificationCode, state.email, state.password, state.confirmPassword);
    if (saved) {
      history.push('/login');
    } else {
      setState({...state, disablebutton: false});
    }
  };

  const alertComponents = alerts.map((alert) => {
    return <Alert className="auth-form-errs rounded text-white text-center"
                  theme={alert.alertType} fade show>
      {alert.msg}
    </Alert>
  });

  const isFormValid = state.isBothMatch && state.isMinimum8ch && state.is1Number
    && state.is1Uppercase && state.is1Lowercase && state.is1SpecialCh && state.password !== '';

  return (
    <Container fluid
               className="main-content-container login-container h-100 px-1 py-4 py-md-0 px-lg-4">
      <Row noGutters className="h-100">
        <Col lg="4" md="5" className="auth-form mx-auto">
          <Card className={"mt-5"}>
            <CardBody>
              <div className="row justify-content-center">
                <label className="font-weight-bold">Account Sign up</label>
              </div>

              {alertComponents}

              <Form onSubmit={handleSignUp}>
                <FormGroup className={"mb-1 mt-3"}>
                  <label className={"text-bold"} htmlFor="email">Email</label>
                  <FormInput
                    type="email"
                    id="email"
                    placeholder="johndoe@test.com"
                    autoComplete="email"
                    name='email'
                    value={state.email}
                    onChange={onChangeEmail}
                    disabled={Boolean(queryParams.login)}
                    required
                  />
                  {state.emailError && <small className="text-danger">{state.emailError}</small>}
                </FormGroup>

                <FormGroup className={"mb-1"}>
                  <label className={"text-bold"} htmlFor="password">Password</label>
                  <div className={"input-group input-group-seamless"}>
                    <FormInput
                      type={state.showPassword ? "text" : "password"}
                      id="password"
                      className={"form-control rounded-right"}
                      placeholder="Enter password"
                      autoComplete="new-password"
                      name='password'
                      value={state.password}
                      onChange={passwordStrength}
                      required
                    />
                    <div className="input-group-append">
                      <span className="input-group-text"><i onClick={e => {
                        setState({...state, showPassword: !state.showPassword})
                      }} className={`fa ${state.showPassword ? "fa-eye" : "fa-eye-slash"} text-secondary`}
                                                              aria-hidden="true"/></span>
                    </div>
                  </div>
                </FormGroup>

                <FormGroup className={"mb-1"}>
                  <label className={"text-bold"} htmlFor="confirmPassword">Confirm Password</label>
                  <div className={"input-group input-group-seamless"}>
                    <FormInput
                      type={state.showConfirmPassword ? "text" : "password"}
                      id="confirmPassword"
                      className={"form-control rounded-right"}
                      placeholder="Confirm password"
                      autoComplete="new-password"
                      name='confirmPassword'
                      value={state.confirmPassword}
                      onChange={passwordMatch}
                      required
                    />
                    <div className="input-group-append">
                      <span className="input-group-text"><i onClick={e => {
                        setState({...state, showConfirmPassword: !state.showConfirmPassword})
                      }} className={`fa ${state.showConfirmPassword ? "fa-eye" : "fa-eye-slash"} text-secondary`}
                                                              aria-hidden="true"/></span>
                    </div>
                  </div>
                  {state.password !== '' && !isFormValid && (
                    <div className="row">
                      <label className={"col-md-6"}><small><i
                        className={"pr-2 fa " + (state.isMinimum8ch ? 'fa-check-circle text-success' : 'fa-times-circle text-danger')}></i>Minimum
                        8 characters</small></label>
                      <label className={"col-md-6"}><small><i
                        className={"pr-2 fa " + (state.is1Number ? 'fa-check-circle text-success' : 'fa-times-circle text-danger')}></i> 1
                        number (0-9)</small></label>
                      <label className={"col-md-6"}><small><i
                        className={"pr-1 fa " + (state.is1Uppercase ? 'fa-check-circle text-success' : 'fa-times-circle text-danger')}></i> 1
                        uppercase letter (A-Z)</small></label>
                      <label className={"col-md-6"}><small><i
                        className={"pr-2 fa " + (state.is1Lowercase ? 'fa-check-circle text-success' : 'fa-times-circle text-danger')}></i>1
                        lowercase letter (a-z)</small></label>
                      <label className={"col-md-12"}><small><i
                        className={"pr-2 fa " + (state.is1SpecialCh ? 'fa-check-circle text-success' : 'fa-times-circle text-danger')}></i>1
                        special character (!, @, #, $, %, ^, &, or *)</small></label>
                      <label className={"col-md-12"}><small><i
                        className={"pr-2 fa " + (state.isBothMatch ? 'fa-check-circle text-success' : 'fa-times-circle text-danger')}></i>Both
                        passwords match</small></label>
                    </div>
                  )}
                </FormGroup>

                <FormGroup className={"mb-4 mt-3"}>
                  <span className="text-muted">
                    By accesing this site, you agree to our <a href={USERTERMS_SERVICE_URL} target="_blank" rel="noopener noreferrer">User Terms of Service</a> and <a
                    href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">Privacy Policy.</a>
                  </span>
                </FormGroup>

                <Button disabled={state.disablebutton || !isFormValid}
                        theme="accent"
                        className="d-table mx-auto px-4 w-100 text-bold mb-1 text-uppercase login-btn"
                        type="submit"
                >
                  Sign up
                </Button>

                <div className="row justify-content-center mt-3">
                  <label>Already have an account? <Link to={{pathname: "/login"}}>Log in</Link></label>
                </div>

                <div className="row justify-content-center">
                  <label className="text-bold text-accent">Ver {version}</label>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

SignUp.propTypes = {
  signup: PropTypes.func.isRequired,
  alerts: PropTypes.array.isRequired,
};
const mapStateToProps = (state) => ({
  alerts: state.alert
});

export default connect(mapStateToProps, {signup})(SignUp);
